(function () {
  if (window.__spfGicFastRender) return;
  window.__spfGicFastRender = true;

  var DEBOUNCE_MS = 60;      // chờ theme vẽ xong drawer rồi render ngay
  var MAX_RENDERS = 6;       // tối đa 6 lần render / 3 giây, chống vòng lặp với theme
  var WINDOW_MS = 3000;

  var renderLog = [];
  var busy = false;
  var timer = null;

  function gic() { return window.tlGiftInCartWidget; }

  function isReady() {
    var w = gic();
    return !!(w && w.targetElements && w.offers && w.offers.length &&
              typeof w.updateAllOfferCardsUI === 'function');
  }

  function getTargets(w) {
    var t = w.targetElements || {};
    var empty = false;
    try { empty = typeof w.isEmptyCart === 'function' && w.isEmptyCart(); } catch (e) {}
    var sel = empty ? t.emptySelector : t.selector;
    if (!sel) return [];
    try { return document.querySelectorAll(sel); } catch (e) { return []; }
  }

  function needRender() {
    if (!isReady()) return false;
    var targets = getTargets(gic());
    if (!targets.length) return false;
    var containers = document.querySelectorAll('.salepify-gic__gic-container');
    return containers.length < targets.length;
  }

  function render() {
    if (busy || !needRender()) return;

    var now = Date.now();
    renderLog = renderLog.filter(function (t) { return now - t < WINDOW_MS; });
    if (renderLog.length >= MAX_RENDERS) return;
    renderLog.push(now);

    busy = true;
    var w = gic();
    // Ép app vẽ lại: xoá container cũ (nếu còn sót) để renderGICWidget chạy lại
    document.querySelectorAll('.salepify-gic__gic-container').forEach(function (el) { el.remove(); });

    Promise.resolve()
      .then(function () { return w.updateAllOfferCardsUI(); })
      .catch(function (e) { console.warn('[SPF GIC fix] render error', e); })
      .then(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(render, DEBOUNCE_MS);
  }

  function start() {
    render();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes.length || list[i].removedNodes.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });

    // Khi app báo cart thay đổi -> kiểm tra lại ngay
    ['TLFREEGIFT:add', 'TLFREEGIFT:change', 'TLFREEGIFT:update', 'TLFREEGIFT:mutate']
      .forEach(function (n) { window.addEventListener(n, schedule); });
  }

  // Đợi app Salepify khởi tạo xong widget
  var tries = 0;
  var wait = setInterval(function () {
    tries++;
    if (isReady()) { clearInterval(wait); start(); }
    else if (tries > 100) clearInterval(wait); // ~30s thì bỏ
  }, 300);
})();
